"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultiSort;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function validateData(data) {
  if (!data || _typeof(data) !== 'object' || Array.isArray(data) && data.length && (Array.isArray(data[0]) || _typeof(data[0]) !== 'object')) {
    throw new Error('It can\'t sort, validate the data sent');
  }
}

function validateKey(key) {
  if (typeof key !== 'string') {
    throw new Error('The key param needs to be a string');
  }
}

function validateParams(data, columns, orderBy, key) {
  validateData(data);
  validateKey(key);
}

function formatArguments(args) {
  var columns = [],
      orderBy = [],
      key = '_key'; //If is Object

  if (args[0] !== null && _typeof(args[0]) === 'object' && !Array.isArray(args[0])) {
    for (var column in args[0]) {
      columns.push(column);
      orderBy.push(args[0][column]);
    }

    key = args[1] || key;
  } else {
    columns = args[0];
    orderBy = args[1];

    if (typeof columns === 'string') {
      columns = [columns];
    }

    if (typeof orderBy === 'string') {
      orderBy = [orderBy];
    }

    key = args[2] || key;
  }

  return {
    columns: columns,
    orderBy: orderBy,
    key: key
  };
}

function formatData(arr, key) {
  if (Array.isArray(arr)) {
    return arr;
  }

  var data = [];

  for (var i in arr) {
    data.push(_objectSpread(_objectSpread({}, arr[i]), {}, _defineProperty({}, key, i)));
  }

  return data;
}

function getValue(column, item) {
  column = column.split('.');
  var value = item;
  column.forEach(function (col) {
    value = value[col];
  });

  if (typeof value === 'boolean' || typeof value === 'undefined') {
    value = value ? 1 : 0;
  }

  return value;
}

function sort(a, b, columns, orderBy, index) {
  var direction = orderBy[index] == 'DESC' ? 1 : 0;
  var aValue = getValue(columns[index], a);
  var bValue = getValue(columns[index], b);
  var isNumeric = !isNaN(+aValue - +bValue),
      x = isNumeric ? +aValue : Array.isArray(aValue) ? aValue : ('' + aValue).toLowerCase(),
      y = isNumeric ? +bValue : Array.isArray(bValue) ? bValue : ('' + bValue).toLowerCase();

  if (x < y) {
    return direction == 0 ? -1 : 1;
  }

  if (x == y) {
    return columns.length - 1 > index ? sort(a, b, columns, orderBy, index + 1) : 0;
  }

  return direction == 0 ? 1 : -1;
}

function MultiSort() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var _formatArguments = formatArguments(args),
      columns = _formatArguments.columns,
      orderBy = _formatArguments.orderBy,
      key = _formatArguments.key;

  validateParams(arr, columns, orderBy, key); //it throws

  return formatData(arr, key).sort(function (a, b) {
    return sort(a, b, columns, orderBy, 0);
  });
}